export default "__VITE_ASSET__Db5e_ZRZ__"